import { render, staticRenderFns } from "./unpaidOrderList.vue?vue&type=template&id=3ec0ced3&scoped=true&"
import script from "./unpaidOrderList.vue?vue&type=script&lang=js&"
export * from "./unpaidOrderList.vue?vue&type=script&lang=js&"
import style0 from "./unpaidOrderList.vue?vue&type=style&index=0&id=3ec0ced3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec0ced3",
  null
  
)

export default component.exports